import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Button } from "@nextui-org/react";
import { useState } from "react";

export default function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isPulsing, setIsPulsing] = useState(false);

  const handleSlideChange = () => {
    setIsPulsing(true);
    setTimeout(() => setIsPulsing(false), 1000);
  };

  const handleTransitionEnd = () => {
    setIsPulsing(true);
  };

  return (
    <Swiper
      dir="rtl"
      className="h-[15rem] md:h-[20rem] lg:h-[25rem] xl:h-[35rem] cursor-pointer home mt-16  "
      breakpoints={{
        320: { slidesPerView: 1, spaceBetween: 10 },
        480: { slidesPerView: 1, spaceBetween: 15 },
        768: { slidesPerView: 1, spaceBetween: 10 },
        958: { slidesPerView: 1, spaceBetween: 10 },
        1028: { slidesPerView: 1, spaceBetween: 10 },
        1400: { slidesPerView: 1, spaceBetween: 10 },
      }}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      loop={true}
      navigation={true}
      pagination={{ dynamicBullets: true }}
      modules={[Navigation, Autoplay, Pagination]}
      onSlideChange={handleSlideChange}
      onTransitionEnd={handleTransitionEnd}
    >
      <div
        className={`hidden md:flex absolute top-[60%] lg:top-1/2 left-[18%] md:left-1/4 transform -translate-x-1/2 -translate-y-1/2 z-10 space-x-4 items-center gap-3 ${
          isPulsing ? "animate-pulse" : ""
        }`}
      >
        {" "}
        <Button
          onClick={() => navigate("/products")}
          radius="md"
          variant="solid"
          className="bg-blue-500 text-white w-20 lg:w-36 sm:w-full"
        >
          <span className="font-bold lg:text-xl">{t("menucatalog")}</span>
        </Button>
        <Button
          onClick={() => navigate("/contact")}
          className="bg-gray-800 text-white w-20 lg:w-36 sm:w-full"
          variant="solid"
          radius="md"
        >
          <span className="font-bold  lg:text-xl">{t("menuconsultation")}</span>
        </Button>
      </div>
      <SwiperSlide key={1}>
        <img
          src={"/Assets/Images/banners/banner3.jpg"}
          className="w-full h-full lg:hidden  "
          alt="1"
        />
        <img
          src={"/Assets/Images/banner3.jpg"}
          className="w-full h-full  hidden lg:block"
          alt="1"
        />
      </SwiperSlide>
      <SwiperSlide key={2}>
        <img
          src={"/Assets/Images/banners/banner2.jpg"}
          className="w-full h-full lg:hidden "
          alt="2"
        />
        <img
          src={"/Assets/Images/banners/banner2 copy.jpg"}
          className="w-full h-full hidden lg:block "
          alt="2"
        />
      </SwiperSlide>
      <SwiperSlide key={3}>
        <img
          src={"/Assets/Images/banners/banner1.jpg"}
          className="w-full h-full lg:hidden"
          alt="3"
        />
        <img
          src={"/Assets/Images/banners/banner1 copy.jpg"}
          className="w-full h-full hidden lg:block"
          alt="3"
        />
      </SwiperSlide>
    </Swiper>
  );
}
